import { http } from "@/lib/http";
export function fetchAppVersions() {
  return http.post("/users/get-app-version").then((res) => {
    const d = res.data;
    return Array.isArray(d) ? d : Array.isArray(d?.data) ? d.data : [];
  });
}
export function fetchAppVersion(id) {
  return http.get(`/users/get-app-version/${id}`).then((res) => res.data);
}
export function updateAppVersion(id, payload) {
  return http
    .put(`/users/get-app-version/update/${id}`, payload)
    .then((res) => res.data);
}
